import { BaseClass } from '@components/BaseClass.js';
/**
 * `ResizeManager` provides a globally available ResizeObserver for components that need to observe when a particular DOM element changes size.
 */
export class ResizeManager extends BaseClass {
    constructor() {
        super();
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
        this.callbacks = new Map();
    }
    handleResize(entries) {
        for (const entry of entries) {
            const targetElement = entry.target;
            // Find the callback associated with this element
            const callback = this.callbacks.get(targetElement);
            if (callback) {
                callback(entry);
            }
        }
    }
    observe(element, fnCallback) {
        if (element) {
            this.callbacks.set(element, fnCallback);
            this.resizeObserver.observe(element);
        }
    }
    unobserve(element) {
        if (element) {
            this.callbacks.delete(element);
            this.resizeObserver.unobserve(element);
        }
    }
    destroy() {
        this.destroyResizeObserver();
        super.destroy();
    }
    destroyResizeObserver() {
        this.resizeObserver.disconnect();
        this.callbacks.clear();
    }
}
